import React, { Fragment, useState } from "react";
import { useForm } from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";

const JobForm = () => {
    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors, isValid },
    } = useForm({
        mode: "onChange", // Validates onChange
        defaultValues: {
            digitalPayment: "digitalPaymentNo", // set the default selected radio
            propertyOwn: "propertyNo",
        },
    });

    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [showFormSubmit, setshowFormSubmit] = useState(null);
    const [errorFormSubmit, seterrorFormSubmit] = useState(0);

    const onReCAPTCHAChange = (token) => {
        setRecaptchaToken(token);
        console.log("reCAPTCHA token:", token);
    };

    const onSubmit = async (formData) => {
        console.log("Form Submitted:", formData);

        if (formData) {
            seterrorFormSubmit(1);
            setTimeout(() => {
                setshowFormSubmit(true);
                resetFrom();
            }, 1000);

            setTimeout(() => {
                setshowFormSubmit(false);
            }, 5000);
        }

        // const data = {
        //     first_name: formData.name,
        //     phone_mobile: formData.phone,
        //     email1: formData.email,
        //     primary_address_city: formData.city,
        // };

        // await axios
        //     .post(process.env.REACT_APP_API_FORM_URL, data, {
        //         headers: {
        //             Authorization: process.env.REACT_APP_AUTHORIZATION,
        //             AUTHORIZEDAPPLICATION:
        //                 process.env.REACT_APP_AUTHORIZED_APPLICATION,
        //             Accept: "application/json, text/plain, */*",
        //             "Content-Type": "application/json;charset=utf-8",
        //             REQUESTEDMODULE: "Lead",
        //             REQUESTEDMETHOD: "Create",
        //         },
        //     })
        //     .then((response) => {
        //         console.log("Response  register form:", response);
        //         console.log("Response register form:", response?.data);
        //         if (response.data.Success) {
        //             seterrorFormSubmit(1);
        //             setshowFormSubmit(true);
        //             resetFrom();
        //             setTimeout(() => {
        //                 setshowFormSubmit(false);
        //             }, 5000);
        //         } else if (response.data?.lead_id) {
        //             seterrorFormSubmit(2);
        //             setshowFormSubmit(true);
        //             resetFrom();
        //             setTimeout(() => {
        //                 setshowFormSubmit(false);
        //             }, 5000);
        //         } else {
        //             seterrorFormSubmit(3);
        //             setshowFormSubmit(true);
        //             setTimeout(() => {
        //                 setshowFormSubmit(false);
        //             }, 5000);
        //         }
        //     })
        //     .catch((error) => {
        //         console.error("Error:", error);
        //     });
    };

    const resetFrom = () => {
        reset();
    };

    return (
        <Fragment>
            <form
                id="contactForm"
                className="row"
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className="col-12 col-sm-6 col-lg-12 mb-7">
                    <input
                        type="text"
                        className={`form-control ${
                            errors.name ? "is-invalid" : ""
                        }`}
                        placeholder="Your Full Name*"
                        {...register("name", {
                            required: "Name is required",
                            minLength: {
                                value: 3,
                                message:
                                    "Name must be at least 3 characters long",
                            },
                        })}
                    />
                    {errors.name && (
                        <p className="text-danger">{errors.name.message}</p>
                    )}
                </div>

                <div className="col-12 col-sm-6 col-lg-12 mb-7">
                    <input
                        type="text"
                        className={`form-control ${
                            errors.phone ? "is-invalid" : ""
                        }`}
                        placeholder="Your Phone Number*"
                        {...register("phone", {
                            required: "Phone number is required",
                            pattern: {
                                value: /^[0-9]{10}$/,
                                message: "Phone number must be 10 digits",
                            },
                        })}
                    />
                    {errors.phone && (
                        <span className="text-danger">
                            {errors.phone.message}
                        </span>
                    )}
                </div>

                <div className="col-12 col-sm-6 col-lg-12 mb-7">
                    <input
                        type="email"
                        className={`form-control ${
                            errors.email ? "is-invalid" : ""
                        }`}
                        placeholder="Your Email*"
                        {...register("email", {
                            required: "Email is required",
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                message: "Invalid email address",
                            },
                        })}
                    />
                    {errors.email && (
                        <span className="text-danger">
                            {errors.email.message}
                        </span>
                    )}
                </div>

                <div className="col-12 col-sm-6 col-lg-12 mb-7">
                    <select
                        className={`form-control ${
                            errors.city ? "is-invalid" : ""
                        }`}
                        {...register("city", {
                            required: "Location selection is required",
                        })}
                    >
                        <option value="">Select Your Location</option>
                        <option value="AP">Andhra Pradesh</option>
                        <option value="AR">Arunachal Pradesh</option>
                        <option value="AS">Assam</option>
                        <option value="BR">Bihar</option>
                        <option value="CT">Chhattisgarh</option>
                        <option value="GA">Gujarat</option>
                        <option value="GA">Goa</option>
                        <option value="HR">Haryana</option>
                        <option value="HP">Himachal Pradesh</option>
                        <option value="JK">Jammu and Kashmir</option>
                        <option value="JH">Jharkhand</option>
                        <option value="KA">Karnataka</option>
                        <option value="KL">Kerala</option>
                        <option value="MP">Madhya Pradesh</option>
                        <option value="MH">Maharashtra</option>
                        <option value="MN">Manipur</option>
                        <option value="ML">Meghalaya</option>
                        <option value="MZ">Mizoram</option>
                        <option value="NL">Nagaland</option>
                        <option value="OR">Odisha</option>
                        <option value="PB">Punjab</option>
                        <option value="RJ">Rajasthan</option>
                        <option value="SK">Sikkim</option>
                        <option value="TN">Tamil Nadu</option>
                        <option value="TG">Telangana</option>
                        <option value="TR">Tripura</option>
                        <option value="UT">Uttarakhand</option>
                        <option value="UP">Uttar Pradesh</option>
                        <option value="WB">West Bengal</option>
                        <option value="AN">Andaman and Nicobar Islands</option>
                        <option value="CH">Chandigarh</option>
                        <option value="DN">Dadra and Nagar Haveli</option>
                        <option value="DD">Daman and Diu</option>
                        <option value="DL">Delhi</option>
                        <option value="LD">Lakshadweep</option>
                        <option value="PY">Puducherry</option>
                    </select>
                    {errors.city && (
                        <span className="text-danger">
                            {errors.city.message}
                        </span>
                    )}
                </div>

                <div className="col-12 col-sm-6 col-lg-12 mb-7">
                    <input
                        className={`form-control ${
                            errors.resume_file ? "is-invalid" : ""
                        }`}
                        type="file"
                        id="resume_file"
                        {...register("terms", {
                            required:
                                "You must agree to the terms and conditions",
                        })}
                    />
                    {errors.resume_file && (
                        <span className="text-danger">
                            {errors.resume_file.message}
                        </span>
                    )}
                </div>

                <div className="col-auto">
                    <div className="form-check mb-2">
                        <input
                            className={`form-check-input ${
                                errors.terms ? "is-invalid" : ""
                            }`}
                            type="checkbox"
                            id="autoSizingCheck"
                            {...register("terms", {
                                required:
                                    "You must agree to the terms and conditions",
                            })}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="autoSizingCheck"
                        >
                            I agree to NeoGrowth’ s Privacy Policy and T&C. I
                            hereby give my consent to NeoGrowth to contact via
                            above mentioned details.
                        </label>
                        {errors.terms && (
                            <span className="text-danger">
                                {errors.terms.message}
                            </span>
                        )}
                    </div>
                </div>

                <div className="col-12 col-sm-12 mb-7">
                    <ReCAPTCHA
                        sitekey="6LfNVKwhAAAAAALvZZhsu-taEYh7NLaAIfkvUU7v"
                        onChange={onReCAPTCHAChange}
                    />
                </div>

                <div className="col-12 text-center">
                    <button
                        type="submit"
                        className={`btn btn-primary btn-hover-primary `}
                        disabled={!recaptchaToken}
                    >
                        Submit
                    </button>
                </div>
            </form>

            <div
                // className={`modal ${1 == 1 ? "show" : ""}`}
                className={`modal ${showFormSubmit ? "show" : ""}`}
                style={{
                    backdropFilter: "blur(2px)",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    opacity: "1 !important",
                }}
            >
                <div className="modal-dialog modal-dialog-centered modal-md ">
                    <div
                        className="modal-content radius-box"
                        style={{ boxShadow: "0px 5px 5px -1px rgb(22 22 22)" }}
                    >
                        {/* <div className="modal-header bg-primary text-white innr-radius-box">
                            <h5 className="modal-title">NeoGrowth</h5>
                            <button
                                type="button"
                                className="btn-close btn btn-primary"
                                aria-label="Close"
                                onClick={() =>
                                    setshowFormSubmit(!showFormSubmit)
                                }
                            ></button>
                        </div> */}
                        <div className="modal-body text-center">
                            {errorFormSubmit == 1 ? (
                                <p className="mt-4 text-center">
                                    <span className="b-color">
                                        Thank you for your application. <br />
                                        <br />
                                        We have received your details and our
                                        team will <br />
                                        connect with you shortly.
                                        <br />
                                    </span>
                                </p>
                            ) : errorFormSubmit == 2 ? (
                                <p className="mt-4 text-center">
                                    <span className="b-color">
                                        We have received your registration.
                                        <br />
                                        <br />
                                        Our team will connect with you shortly.
                                    </span>
                                </p>
                            ) : (
                                <p className="mt-4 text-center">
                                    <span className="b-color">
                                        Technical error occurred.
                                        <br />
                                        <br />
                                        Please try again after sometime.
                                    </span>
                                </p>
                            )}
                            <button
                                type="button"
                                className="btn btn-sm btn-primary btn-hover-primary mt-2"
                                aria-label=""
                                onClick={() =>
                                    setshowFormSubmit(!showFormSubmit)
                                }
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default JobForm;
